import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-mask",
  templateUrl: "./field-set-mask.component.html",
  styles: [],
})
export class FieldSetMaskComponent {

  @Input() public fieldOptions: any;
  @Output() public dataChanged = new EventEmitter();

  public dataChangedEvent(event) {
    this.dataChanged.emit(event);
  }

}
